import { useEffect, useState } from 'react';

const TOUCH_QUERY = '(hover: none) and (pointer: coarse)';

const detectTouchDevice = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  return hasTouch && window.matchMedia(TOUCH_QUERY).matches;
};

/**
 * True on devices whose primary input is a coarse pointer without hover (phones, tablets).
 */
const useIsTouchDevice = (): boolean => {
  const [isTouchDevice, setIsTouchDevice] = useState(detectTouchDevice);

  useEffect(() => {
    const mediaQuery = window.matchMedia(TOUCH_QUERY);
    const handleChange = (): void => setIsTouchDevice(detectTouchDevice());

    handleChange();
    mediaQuery.addEventListener('change', handleChange);
    window.addEventListener('resize', handleChange);

    return () => {
      mediaQuery.removeEventListener('change', handleChange);
      window.removeEventListener('resize', handleChange);
    };
  }, []);

  return isTouchDevice;
};

export default useIsTouchDevice;
